import { render, staticRenderFns } from "./friendsfissionEdit.vue?vue&type=template&id=264fe25a&scoped=true"
import script from "./friendsfissionEdit.vue?vue&type=script&lang=js"
export * from "./friendsfissionEdit.vue?vue&type=script&lang=js"
import style0 from "./friendsfissionEdit.vue?vue&type=style&index=0&id=264fe25a&prod&lang=less&scoped=true"
import style1 from "./friendsfissionEdit.vue?vue&type=style&index=1&id=264fe25a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264fe25a",
  null
  
)

export default component.exports